/* Avirelle · Trenner (v22, 03.10.2026) – wählt pro Seitenaufruf EIN Motiv zufällig, misst die Fläche und bewegt das Bild beim Scrollen (Parallax).
   Kein Wechsel während des Besuchs, kein Slider. Bei „Bewegung reduzieren“ steht das Bild still.
   AVIRELLE 03.10.2026 · v37 — erstes Messen (mass + Parallax) und das Nachmessen nach dem Laden der Schrift erst im
   ResizeObserver-Rückruf: der kommt nach der Layout-Berechnung und vor dem Malen desselben Bildes – gleiche Werte, gleiches Bild,
   aber kein erzwungener Umbruch direkt nach dem Einsetzen des Motivs (Lighthouse v36: ~11 ms). Rückbau: Datei aus v36 zurückspielen. */
(function () {
  function init(root) {
    if (root.avzOk) return; root.avzOk = true;
    var box = root.querySelector('.avz'), txt = root.querySelector('.avz-text');
    var tpl = [].slice.call(root.querySelectorAll('template[data-avz-motiv]'));
    if (!box || !tpl.length) return;
    var t = tpl[Math.floor(Math.random() * tpl.length)];
    box.insertBefore(t.content.cloneNode(true), box.firstChild);
    var a = root.querySelector('[data-avz-stueck]');
    if (a) { a.href = t.getAttribute('data-url'); a.setAttribute('aria-label', (a.textContent || '').trim() + ': ' + t.getAttribute('data-titel')); }
    var img = box.querySelector('.avz-bild');

    // Desktop: Weiss reicht bis hinter das Wort (--tr), das ganze Foto steht gross in der freien rechten Fläche (--cx, --gs)
    function mass() {
      var b = box.getBoundingClientRect(), tr = txt.getBoundingClientRect().right - b.left;
      box.style.setProperty('--tr', Math.round(tr) + 'px');
      box.style.setProperty('--cx', Math.round((tr + b.width) / 2) + 'px');
      box.style.setProperty('--gs', Math.round(b.height * 1.6) + 'px');
    }

    var ruhig = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches, laeuft = false;
    function rahmen() {
      laeuft = false;
      var r = box.getBoundingClientRect();
      if (ruhig || r.bottom < 0 || r.top > innerHeight) return;
      var mitte = (r.top + r.height / 2) - innerHeight / 2;
      var max = r.height * (innerWidth < 700 ? 0.07 : 0.2);              // nie über die Bildreserve hinaus
      img.style.setProperty('--pp', Math.max(-max, Math.min(max, mitte * -0.3)).toFixed(1) + 'px');
    }
    function bitte() { if (!laeuft) { laeuft = true; requestAnimationFrame(rahmen); } }

    // v37: fn einmal nach der nächsten Layout-Berechnung (frischer ResizeObserver meldet sich sofort danach, vor dem Malen)
    function nachLayout(fn) {
      if (!('ResizeObserver' in window)) { fn(); return; }
      var ro = new ResizeObserver(function () { ro.disconnect(); fn(); }); ro.observe(box);
    }
    nachLayout(function () {   // v37: vorher mass(); bitte(); – Parallax zuerst: liest nur die Box, die mass() nicht verändert
      // Wortbreite erst mit geladener Schrift exakt (v37: erst hier abgefragt – document.fonts.ready erzwingt sonst sofort eine Stilberechnung, ~21 ms)
      // (Schrift schon geladen → mass() unten misst bereits mit ihr, ein zweites Messen ergäbe dieselben Werte)
      if (document.fonts && document.fonts.ready && document.fonts.status !== 'loaded') document.fonts.ready.then(function () { nachLayout(mass); });
      rahmen(); mass();
    });
    addEventListener('scroll', bitte, { passive: true });
    addEventListener('resize', function () { mass(); bitte(); });
  }
  function alle() { [].forEach.call(document.querySelectorAll('[data-avz-root]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle); else alle();
  document.addEventListener('shopify:section:load', alle);   // Theme-Editor
})();
